import React, { createContext, useContext, ReactNode } from 'react';
import { usePlaylistRealtime, Playlist } from '@/hooks/usePlaylistRealtime';
import { useAuth } from '@/hooks/useAuth';

interface PlaylistContextType {
  playlists: Playlist[];
  playlistVideos: {[key: string]: string[]};
  favorites: string[];
  isLoading: boolean;
}

const PlaylistContext = createContext<PlaylistContextType | undefined>(undefined);

interface PlaylistProviderProps {
  children: ReactNode;
}

export const PlaylistProvider: React.FC<PlaylistProviderProps> = ({ children }) => {
  const { user } = useAuth();
  const { playlists, playlistVideos, favorites, isLoading } = usePlaylistRealtime(user?.id);

  const value = {
    playlists,
    playlistVideos,
    favorites,
    isLoading
  };

  return (
    <PlaylistContext.Provider value={value}>
      {children}
    </PlaylistContext.Provider>
  );
};

export const usePlaylistContext = () => {
  const context = useContext(PlaylistContext);
  if (context === undefined) {
    throw new Error('usePlaylistContext must be used within a PlaylistProvider');
  }
  return context;
};